import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Reversal from "./components/Reversal";
import Timeline from "./components/Timeline";
import Responses from "./components/Responses";
import Tracking from "./components/Tracking";
import About from "./components/About";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Feed />
        <Reversal />
        <Timeline />
        <Responses />
        <Tracking />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}